import { regionCodesConfigurationGroupsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("region-code-preset"),
  endpoint: "region-codes-configuration-groups",
  operations: regionCodesConfigurationGroupsOps,
  roleView: [ROLE.REGION_CODE_VIEW, ROLE.REGION_CODE_ADMIN],
  roleAdmin: [ROLE.REGION_CODE_ADMIN],
  singularName: (t) => t("Region Code preset"),
  name: (t) => t("Region Code presets"),
  syncCustomerFilter: true,
  dependencies: ["container"],
});

export default conf;
